import { Hats } from '../../../@resources/hats';

export type HatType = keyof typeof Hats;

export type HatWearInstr = ['wear', string];
export type HatThrowInstr = ['throw', string, [number, number, number, number], string];
export type HatInstr = HatWearInstr | HatThrowInstr;
export type HattingState = Record<string, HatInstr | null>;

const createSettings = (mask: boolean, scale: number, x: string, y: string) => ({ mask, scale, x, y });
type Settings = ReturnType<typeof createSettings>;

const lookup: Record<HatType, Settings> = {
    Jester: createSettings(true, 2.2, '-1%', '-24%'),
    BunnyEars: createSettings(true, 1.5, '1%', '-68%'),
    KidsAnimal: createSettings(true, 1.3, '2%', '-50%'),
    Builder: createSettings(true, 1.1, '1%', '-44%'),
    RoyalCrown: createSettings(true, 1.4, '0%', '-65%'),
    Usher: createSettings(true, 1.4, '-1%', '-25%'),
    Fez: createSettings(true, 1.2, '10%', '-38%'),
    Sombrero: createSettings(true, 1.8, '0%', '-35%'),
    RobinHood: createSettings(true, 1.1, '2%', '-62%'),
    Bag: createSettings(false, 1.3, '0%', '-5%'),
    Beret: createSettings(false, 1.3, '4%', '-48%'),
    Bonnet: createSettings(false, 1.2, '0%', '-52%'),
    Bowler: createSettings(false, 1.3, '0%', '-53%'),
    Bow: createSettings(true, 1.1, '0%', '-45%'),
    Captain: createSettings(false, 1.2, '0%', '-60%'),
    Ceremonial: createSettings(false, 1.75, '0%', '-45%'),
    Chef: createSettings(false, 1.25, '-6.5%', '-65%'),
    Chinese: createSettings(true, 1.75, '0', '-0%'),
    Cowboy: createSettings(true, 1.4, '0%', '-35%'),
    Fedora2: createSettings(false, 1.1, '0%', '-55%'),
    Fedora: createSettings(false, 1.2, '0%', '-45%'),
    FloppyRed: createSettings(true, 1.75, '0', '-15%'),
    FloppySun: createSettings(true, 2.0, '0%', '-13%'),
    Floral: createSettings(true, 1.2, '0', '-30%'),
    Pirate: createSettings(false, 2.2, '0%', '-15%'),
    Plaid: createSettings(true, 1.1, '0%', '-40%'),
    Police: createSettings(false, 1.0, '0%', '-53%'),
    Sailor: createSettings(false, 1.0, '0%', '-56%'),
    Santa: createSettings(false, 1.1, '-11%', '-54%'),
    Scholar: createSettings(true, 1.5, '0%', '-30%'),
    Sheriff: createSettings(false, 1.2, '0%', '-50%'),
    Spanish: createSettings(false, 1.35, '0%', '-20%'),
    Straw1: createSettings(true, 1.7, '0%', '-12%'),
    Straw2: createSettings(true, 2.2, '0', '5%'),
    Top: createSettings(false, 1.1, '0%', '-70%'),
    Trilby: createSettings(true, 1.3, '0%', '-50%'),
    Turban1: createSettings(false, 1.2, '0%', '-38%'),
    Turban2: createSettings(true, 1.2, '0%', '-38%'),
    Turban3: createSettings(true, 1.2, '0%', '-32%'),
    Warden: createSettings(false, 1.0, '0%', '-53%'),
    Witch: createSettings(true, 1.3, '0%', '-47%'),
};

export type HatSettings = Settings;
export const HatSettings = Object.assign(
    createSettings,
    {
        lookup(type: string): HatSettings {
            return lookup[type] ?? null;
        }
    }
);
